import React, { useRef, useEffect, useState } from "react";
import styled from "@emotion/styled";

import Filter from "./Filter";
import SearchBar from "./SearchBar";

//style rules
import { Sizes } from "../../styles";

const renderFilters = (filtersList, filterRefs) => {
	if (!Object.keys(filtersList).length > 0) return null;

	return Object.keys(filtersList).map((filter, index) => {
		return (
			<FilterContainer
				key={index}
				ref={(el) => (filterRefs.current[index] = el)}
			>
				<Filter filters={filtersList[filter]} index={index} />
			</FilterContainer>
		);
	});
};

const Filters = ({ filtersList, setFilters, searchTerm, setSearchTerm, setCurrentPage }) => {
	const [filterWidths, setFilterWidths] = useState([]);
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const filterRefs = useRef([]);

	// Track the current applied filters
	const [appliedFilters, setAppliedFilters] = useState({
		category: "",
		type: "",
	});

	// Get the width of each filter for alignment
	useEffect(() => {
		const widths = filterRefs.current.map((ref) => ref?.offsetWidth || 0);
		setFilterWidths(widths);
	}, [filtersList]);

	const handleSubmit = (event) => {
		event.preventDefault();

		// Extract selected filters
		const newFilters = {
			category: event.target.elements.media_category.value || "",
			type: event.target.elements.media_type.value || "",
		};

		// Only update filters and reset page if new filters are different
		if (
			newFilters.category !== appliedFilters.category ||
			newFilters.type !== appliedFilters.type
		) {
			setFilters(newFilters);
			setAppliedFilters(newFilters);
			setCurrentPage(1);
		}
	};

	return (
		<Container isSearchOpen={isSearchOpen}>
			<FiltersContainer className="index-page__filters">
				<form action="submit" onSubmit={handleSubmit}>
					{renderFilters(filtersList, filterRefs)}
					<Buttons className="index-page__filters__buttons">
						<button type="submit">Apply Filters</button>
						<Clear
							onClick={() => {
								setFilters({ category: "", type: "" });
								setAppliedFilters({ category: "", type: "" });
								setCurrentPage(1);
							}}
						>
							Clear Filters
						</Clear>
					</Buttons>
				</form>
			</FiltersContainer>
			<SearchBar
				isSearchOpen={isSearchOpen}
				setIsSearchOpen={setIsSearchOpen}
				filterWidths={filterWidths}
				searchTerm={searchTerm}
				setSearchTerm={setSearchTerm}
			/>
		</Container>
	);
};


const Buttons = styled.div`
	@media only screen and (min-width: ${Sizes.screens.large}) {
		margin-left: 1rem;
	}

	@media only screen and (min-width: ${Sizes.screens.xlarge}) {
		margin-left: 3rem;
	}
`;

const Clear = styled.span`
	margin-left: 1rem !important;

	@media only screen and (min-width: ${Sizes.screens.large2}) {
		margin-left: 3rem !important;
	}
`;
const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 6rem;
  margin-bottom: ${(props) => (props.isSearchOpen ? "13rem" : "6rem")};);

  @media only screen and (min-width: ${Sizes.screens.large}) {
	align-items: center;
	margin-bottom: 0;
}
`;

const FiltersContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;

	> form {
		flex-direction: column;

		@media only screen and (max-width: ${Sizes.screens.large}) {
			margin: 0;
		}

		@media only screen and (min-width: ${Sizes.screens.large}) {
			flex-direction: row;
		}
	}
`;

const FilterContainer = styled.div`
	width: auto;
	min-width: calc(100% / 3);
`;

export default Filters;
